export interface ValidateTokenRequest {
  email: string
  token: string
}

export interface ValidateTokenResponse {
  validToken: boolean
}
